import {CreateUpdateJobStatusApiDto, JobStatusApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import {JobStatusCategoryEnum} from "./JobStatusCategory";
import {JobStatusExternalCategoryEnum} from "./JobStatusExternalCategory";

export default class JobStatus {
	/**
	 * Job status object.
	 * @param {string} id Job status id.
	 * @param label Job status label.
	 * @param category Job status category.
	 * @param externalLabel Job status external label.
	 * @param {JobStatusExternalCategoryEnum} externalCategory Job status external category.
	 * @param description Job status description.
	 * @param disabled Indicates if status is disabled.
	 * @param showPushNotification
	 */
	constructor(public readonly id: string,
		public readonly label: string,
		public readonly category: string,
		public readonly externalLabel: string,
		public readonly externalCategory: JobStatusExternalCategoryEnum,
		public readonly description: string,
		public readonly disabled: boolean,
		public readonly showPushNotification: boolean) {}

	static fromJson(json: JobStatusApiDto): JobStatus {
		return new JobStatus(json.id, json.label, json.category, json.externalLabel,
			JobStatusExternalCategoryEnum[json.externalCategory], json.description, json.disabled, json.showPushNotification);
	}

	toJson(): CreateUpdateJobStatusApiDto {
		const json: CreateUpdateJobStatusApiDto = {
			label: this.label,
			category: this.category,
			externalLabel: this.externalLabel,
			externalCategory: this.externalCategory,
			description: this.description,
			showPushNotification: this.showPushNotification
		};
		return JsonConverter.removeEmptyFields(json);
	}

	/**
	 * @param {boolean} labelWithDisabled add disabled description if true
	 * @returns {string} job status display label.
	 */
	public getStatusLabel(labelWithDisabled?: boolean): string {
		return (labelWithDisabled && this.disabled) ? `${this.label} (disabled)` : this.label;
	}

	/**
	 * Get icon for given status.
	 * @return {string}
	 */
	public getStatusIcon() {
		switch (this.category) {
			case JobStatusCategoryEnum.Pending:
				return "icn-act-new.svg";
			case JobStatusCategoryEnum.Completed:
				return "icn-act-won.svg";
			default:
				return "icn-act-new.svg";
		}
	}

	copy({
		label = this.label, category = this.category, externalLabel = this.externalLabel, externalCategory = this.externalCategory,
		description = this.description, disabled = this.disabled
	}) {
		return new JobStatus(this.id, label, category, externalLabel, externalCategory, description, disabled,
			this.showPushNotification);
	}
}
